<template>
  <ReportAgent :urls="urls" :mandatory-filter="mandatoryFilter" />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportAgent from "@/own/components/reports/ReportAgent";
export default {
  name: "ReportAsnSkuSerial",
  components: { ReportAgent },
  data: () => ({
    urls: {
      data_url: "/reports/reportAsnSkuSerial",
      show_url: "/reports/reportAsnSkuSerial/show",
    },
  }),
  computed: {
    mandatoryFilter() {
      return [
        {
          name: "date_range",
          title: this.$t("date_range"),
          valueFieldName: ".date",
        },
      ];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
